import { defineMessages } from 'react-intl';
export default defineMessages({
	title: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.title',
		defaultMessage: "Jira's better when used together",
		description: 'Title for invite users page of the onboarding wizard.',
	},
	titleSubmitting: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.title-submitting',
		defaultMessage: 'Setting up your space',
		description: 'Title for invite users page of the onboarding wizard while submitting.',
	},
	bodyLineOne: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.body-line-one',
		defaultMessage:
			'Jira works better with your team onboard. Invite a teammate to try it out with you.',
		description: 'The main text content within invite page of the modal.',
	},
	bodyLineOneSubmitting: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.body-line-one-submitting',
		defaultMessage: 'Hold tight while we finish setting things up...',
		description: 'The main text content within invite page of the modal while submitting.',
	},
	linkShare: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.link-share',
		defaultMessage: 'Share via link',
		description: 'Label text for the copy link field.',
	},
	linkShareCopiedPopup: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.link-shared-copied-popup',
		defaultMessage: 'Link copied to clipboard',
		description:
			'Content for the link copied to clipboard popup, shown after user clicks copy link button.',
	},
	copyShareLinkCta: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.copy-share-link-cta',
		defaultMessage: 'Copy link',
		description: 'Label text for the copy share link CTA.',
	},
	emailShare: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.email-share',
		defaultMessage: 'Invite via email',
		description: 'Label text for the email invite field.',
	},
	emailSharePlaceholder: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.email-share-placeholder',
		defaultMessage: 'e.g. maria@company.com',
		description: 'Placeholder text for the email invite field.',
	},
	doThisLater: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.do-this-later',
		defaultMessage: 'Do this later',
		description: 'Button text to skip inviting users and go to Jira.',
	},
	goToJira: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.go-to-jira',
		defaultMessage: 'Go to Jira',
		description: 'Button text to add users and go to Jira.',
	},
	inviteAndGoToJira: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.invite-and-go-to-jira',
		defaultMessage: 'Invite and go to Jira',
		description: 'Button text to add users and go to Jira when emails have been manually added.',
	},
	getStarted: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.get-started',
		defaultMessage: 'Get started',
		description:
			'TWCG-2503 treatment label for the terminal button on the invite step, shown when no emails have been added.',
	},
	inviteAndGetStarted: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.invite-and-get-started',
		defaultMessage: 'Invite and get started',
		description:
			'TWCG-2503 treatment label for the terminal button on the invite step, shown when emails have been manually added.',
	},
	emailMaxExceeded: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.email-max-exceeded',
		defaultMessage: 'You can invite up to {maxAllowedEmails} people at a time.',
		description: 'Error shown when the user tries to add more than the maximum allowed emails.',
	},
	emailInvalidFormat: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.email-invalid-format',
		defaultMessage: 'Enter a valid email address.',
		description: 'Error shown when the user tries to add an invalidly formatted email address.',
	},
});
